import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import { downloadFile } from '../../services/utils';
import { annualGratificationReportRequest } from '../../requests/payrollProcessesReports';
import FiltersAnnualGratification from './FiltersAnnualGratification';

const AnnualGratificationReport = () => {
  const dispatch = useDispatch();
  const [report, setReport] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { currentCompany } = useSelector(state => state.auth);

  const handleRequest = (params, setSubmitting) => {
    setIsLoading(true);
    annualGratificationReportRequest({
      dispatch,
      params: {
        ...params,
        filter_by_company: currentCompany.id,
        sort_year_month_options: 'desc'
      },
      format: params.format,
      successCallback: response => {
        downloadFile(response);
        setIsLoading(false);
        setSubmitting(false);
      },
      failureCallback: () => {
        setIsLoading(false);
        setSubmitting(false);
      },
      callback: () => {
        setIsLoading(false);
        setSubmitting(false);
      }
    });
  };

  return (
    <>
      <FiltersAnnualGratification
        report={report}
        isLoading={isLoading}
        setReport={setReport}
        formRequest={handleRequest}
      />
      <div className="position-relative">
        {isLoading && (
          <div className="containerSpinnerLoad position-absolute h-100 w-100">
            <Spinner animation="border" variant="primary" />
          </div>
        )}
      </div>
    </>
  );
};

export default AnnualGratificationReport;
